import { render } from "./ServiciosComp.vue?vue&type=template&id=258e017f&scoped=true"
import script from "./ServiciosComp.vue?vue&type=script&lang=js"
export * from "./ServiciosComp.vue?vue&type=script&lang=js"

import "./ServiciosComp.vue?vue&type=style&index=0&id=258e017f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-258e017f"]])

export default __exports__